"use strict";

import moment from "moment";
import { initLottie } from "../utils";
import { SchedulingCalendarWidget } from "./_scheduling-calendar-widget/scheduling-calendar-widget";
import { Analytics } from "../analytics";
import { DatePicker } from "../appointments/_date-picker/datePicker";
class ProviderDetailsSchedulingWidget {
	constructor(patientInfo = {}) {
		this.container = document.querySelector(".body-container.schedule-an-appointment-page.physician-page, .body-container.physician-page.only-list");
		if (!this.container) {
			return;
		}
		this.patientInfo = patientInfo;

		this.schedulingCalendarWidget = new SchedulingCalendarWidget(
			'schedulingWidgetContainer',
			date => {
				let formattedDate = moment(date, 'YYYY-MM-DD').format('dddd, MMMM Do YYYY');
				this.container.querySelector('#appointmentDate').innerText = formattedDate;
				this.searchParams.set("date", date);
				this.schedulingCalendarWidget.toggleVisibility();
				initLottie();
				this.updateTimes();
			});
		
		this.setupCareTeamEventListeners();

		this.searchParams = new URLSearchParams(window.location.search);
		this.analytics = new Analytics(false);
		this.visitTypeListeners();
		this.onClickListener();
		this.setSlotListeners();

		// on page load, load appointments data for today
		const date = this.container.querySelector('.times').dataset.firstDateWithAvailability;
		let formattedDate = moment(date, 'YYYY-MM-DD').format('dddd, MMMM Do YYYY');
		this.container.querySelector('#appointmentDate').innerText = formattedDate;
		this.container.querySelector('#appointmentDate').dataset.date = date;
		this.searchParams.set("date", date);
		initLottie();
		this.updateTimes();
		const continueCta = document.querySelector('#continue button');
        if (!continueCta) {
            return;
        }
        continueCta.addEventListener('click', () => {
			this.analytics._sendEvent('continue_to_patient_info_click', {
				Schedule_Flow_Type: document.querySelector('[name="schedule-flow-type"]')?.value ?? "Providers Flow"
			});
        });

		this.datePicker = new DatePicker(currentDate => this.datePickerCallback(currentDate));
	}

	setupCareTeamEventListeners() {
		if (!this.container.classList.contains('schedule-an-appointment-page')) {
			return;
		}
        const physicianCards = document.querySelectorAll('.careTeam div.physician-link')
        physicianCards.forEach((card) => {
			const scheduleCta = card.querySelector(".scheduleOnline a");
			if (scheduleCta) {
				card.addEventListener('click', async (e) => {
					e.preventDefault();
					const url = window.location.href
					const csrfToken = document.querySelector("input#csrf-token");					
					const response = await fetch(url, {
						method: 'POST',
						mode: 'same-origin',
						cache: 'no-cache',
						follow: true,
						async: true,
						credentials: 'same-origin',
						headers: {
							'Content-Type': 'application/json',
							'x-isAjax': true
						},
						
						body: JSON.stringify({
							'newProvider': '1',
							'appointment_physician_id': card.dataset.providerId,
							'outsideOfScheduling': true,
							[csrfToken.name]: csrfToken.value
						})
					});
					const data = await response.json();
					const { success } = data;
					if (success) {
						window.location.reload();
					} else {
						console.error(data)
					}
				})
			}
        })
    }

	datePickerCallback(currentDate) {
		this.searchParams.set("date", currentDate.format("YYYY-MM-DD"));
		initLottie();
		this.updateTimes();
    }

	visitTypeListeners() {
		this.container.querySelectorAll('.visit-type input').forEach(input => {
			input.parentElement.setAttribute('data-active', input.checked )
			input.addEventListener('click', _ => {
				let el = _.target;
				el.parentElement.setAttribute('data-active', el.checked ) ;
				initLottie();
				this.searchParams.delete("visit_type[]");
				if (
					!this.container.querySelector('.visit-type #inClinic').checked
					&& this.container.querySelector('.visit-type #videoVisit').checked
				) {
					this.searchParams.set("visit_type[]", 'video visit');
				} else if (
					this.container.querySelector('.visit-type #inClinic').checked
					&& !this.container.querySelector('.visit-type #videoVisit').checked
				) {
					this.searchParams.set("visit_type[]", 'in-clinic');
				}
				this.updateTimes();
			});

		})
	}

	setRecommendedProviderListeners() {
		this.container.querySelectorAll('.recommended-physicians a').forEach(a => {
			a.addEventListener('click', e => {
				e.preventDefault();

				const url = '/schedule';
				const csrfToken = document.querySelector("input#csrf-token");
				let body = {};
				body[csrfToken.name] = csrfToken.value;

				const target = e.target == a ? a : e.target.closest('a');
				body['appointment_physician_id'] = target.dataset.id;
				body['newProvider'] = true;
				body['appointment_selected_recommended_physician_id'] = target.dataset.id;
				fetch(url, {
					method: 'POST',
					mode: 'same-origin',
					cache: 'no-cache',
					follow: true,
					async: true,
					credentials: 'same-origin',
					headers: {
						'Content-Type': 'application/json',
						'x-isAjax': true
					},
					body: JSON.stringify(body)
				}).then(async (response) => {
					const text = await response.text();
					if (response.ok) {
						if (document.querySelector(".body-container.schedule-an-appointment-page.physician-page")) {
							window.location.reload(true);
						} else {
							window.location = target.closest('a').href;
						}
					} else {
						return Promise.reject(text);
					}
				}).then(async (data) => {
					this.setLoading(false);
					return data;
				})
			});
		})
	}

	onClickListener() {
		this.container.querySelector('#scheduling-calendar-widget').addEventListener('click', e => {
			e.stopPropagation();
			e.preventDefault();
			this.schedulingCalendarWidget.toggleVisibility();
		});
	}

	async updateTimes() {
		const times = this.container.querySelector(".times .details");
		const url = `${window.location.protocol}//${window.location.host}/schedule/provider-details?${this.searchParams.toString()}`;
		// window.history.replaceState(null, "", url);
		this.setLoading(true);
		times.innerHTML = "";
		const response = await fetch(url, {
			method: "GET",
			mode: "same-origin",
			cache: "no-cache",
			follow: true,
			async: true,
			credentials: "same-origin",
			headers: {
				Accept: "text/html",
				"x-isAjax": true,
			},
		});
		this.setLoading(true);
		const html = await response.text();
		times.innerHTML = html;
		initLottie();
		this.setSlotListeners();
		this.setLoading(false);
		this.setRecommendedProviderListeners();
	}

	setLoading(loading) {
		const loader = this.container.querySelector("#dulyLoader");
		if (loading) {
			if (document.querySelector("#continue button")) {
				document.querySelector("#continue button").disabled = true;
			}
			loader.classList.remove("hidden");
		} else {
			loader.classList.add("hidden");
			if (this.container.querySelector('.recommended-physicians')) {
				this.container.querySelector('.recommended-physicians').classList.remove('collapsed');
			}
		}
	}

	setSlotListeners() {
		const buttons = document.querySelectorAll(".slot button");
		const continueCta = document.querySelector("#continue button");
		const appointmentVisitTypeId = document.querySelector(
			'input[name="appointment_visit_type_id"]'
		);
		const appointmenDepartmentId = document.querySelector(
			'input[name="appointment_department_id"]'
		);
		const appointmentPhysicianId = document.querySelector(
			'input[name="appointment_physician_id"]'
		);
		const appointmentTime = document.querySelector(
			'input[name="appointment_time"]'
		);
		if (continueCta) {
			continueCta.disabled = true;
		}
		buttons.forEach((button) => {
			button.addEventListener("click", (e) => {
				e.preventDefault();
				buttons.forEach((button) =>
					button.classList.remove("selected")
				);
				button.classList.add("selected");
				appointmentVisitTypeId.value = button.dataset.visitTypeId;
				appointmenDepartmentId.value = button.dataset.departmentId;
				appointmentPhysicianId.value = button.dataset.providerId;
				continueCta.disabled = false;

				const date = moment(button.closest('.appointment-times').querySelector('.date').dataset.date);
				appointmentTime.value = moment(date.format('YYYY-MM-DD') + " " + button.innerText, 'YYYY-MM-DD h:mm A').format();
			});
		});

		const recommendedProviderSlots = document.querySelectorAll('.recommended-physicians .slot button');
		if (recommendedProviderSlots) {
			recommendedProviderSlots.forEach((slot) => {
				slot.addEventListener('click', () => {
					this.patientInfo.appointment_selected_recommended_physician_id = slot.dataset.providerId;
					const recommendedProviderInput = document.querySelector('input[name="appointment_selected_recommended_physician_id"]');
					if (recommendedProviderInput) {
						recommendedProviderInput.value = slot.dataset.providerId;
					}
					this.analytics._sendEvent('recommended_provider_time_block');
				})
			})
		}
		const recommendedViewAll = document.querySelectorAll('.recommended-physicians .viewAll a');
		if (recommendedViewAll) {
			recommendedViewAll.forEach((viewAll) => {
				viewAll.addEventListener('click', () => this.analytics._sendEvent('recommended_provider_view_all_click'));
			})
		}

		if (!continueCta) {
			return;
		}
		continueCta.addEventListener('click', e => {
			if (document.querySelector(".body-container.physician-page.only-list")) {
				e.preventDefault();
				const appointmenDepartmentId = document.querySelector(
					'input[name="appointment_department_id"]'
				);
				const appointmentVisitTypeId = document.querySelector(
					'input[name="appointment_visit_type_id"]'
				);
				const appointmentPhysicianId = document.querySelector(
					'input[name="appointment_physician_id"]'
				);
				const appointmentTime = document.querySelector(
					'input[name="appointment_time"]'
				);

				let url = new URL(window.location.href);
				url.pathname = '/schedule';

				const csrfToken = document.querySelector("input#csrf-token");
				let body = this.patientInfo;
				body[csrfToken.name] = csrfToken.value;
				body.appointment_department_id = appointmenDepartmentId.value;
				body.appointment_visit_type_id = appointmentVisitTypeId.value;
				body.appointment_physician_id = appointmentPhysicianId.value;
				body.appointment_time = appointmentTime.value;
				body.apointment_time_selected_outside_of_scheduling = "1";

				const data = fetch(url, {
					method: 'POST',
					mode: 'same-origin',
					cache: 'no-cache',
					follow: true,
					async: true,
					credentials: 'same-origin',
					headers: {
						'Content-Type': 'application/json',
						'x-isAjax': true
					},
					body: JSON.stringify(body)
				}).then(async (response) => {
					const text = await response.text();
					if (response.ok) {
						window.location = `${url}/confirm-provider`;
					} else {
						return Promise.reject(text);
					}
				}).then(async (data) => {
					this.setLoading(false);
					return data;
				})
			}
		})
	}
}

export { ProviderDetailsSchedulingWidget };
